import { ArchivedCommitteeMember } from "./ArchivedCommitteeMember";

export default ArchivedCommitteeMember;
